import { Controller } from "@hotwired/stimulus"

// Inline "add a location" form inside the unit form flow. Focuses the new
// location name on connect and clears the inline form when cancelled (leaving
// the surrounding Turbo Frame in place so it can be reopened).
export default class extends Controller {
  static targets = ["name"]

  connect() {
    if (this.hasNameTarget) this.nameTarget.focus()
  }

  cancel() {
    this.element.remove()
  }
}
